import type { ChatRoomListResponsePageAllOfThreeContentItem } from './chatRoomListResponsePageAllOfThreeContentItem';

export type ChatRoomListResponsePageAllOfThree = {
  /** 채팅방 목록 */
  content?: ChatRoomListResponsePageAllOfThreeContentItem[];
};
